<template>
  <div v-if="isLoading" class="mt-4">
    <div class="flex justify-center items-center h-full">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryDarkBg"></div>
    </div>
  </div>

  <div v-else-if="!isLoading && tasks.length > 0" class="mt-4">
    <!-- <div class="flex items-center gap-4 px-8 py-2 bg-primaryBg">
      <div>
        <div
          class="flex items-center gap-2 px-4 py-2 border border-grayLight rounded cursor-pointer"
          @click="toggleStatusDropdown"
        >
        Today
        </div>
      </div>

      <div>
        <div
          class="flex items-center gap-2 px-4 py-2 border border-grayLight rounded cursor-pointer"
          @click="toggleAssigneeDropdown"
        >
          Day
          <img src="@/assets/projects/chevron-down.svg" alt="Dropdown Icon" />
        </div>
      </div>
    
    
    </div> -->
     
  <div class="timeline-container">
    <!-- Header with Days -->
    <div class="flex items-center border-b border-gray-300 p-2 bg-gray-100">
      <!-- <button 
        class="px-2 py-1 border border-gray-300 rounded hover:bg-gray-200 focus:outline-none" 
        @click="scrollLeft"
      >
        ◀
      </button> -->
      <div class="flex-grow flex overflow-x-auto">
        <div
          v-for="day in days"
          :key="day"
          class="flex-1 text-center p-2 text-sm font-medium"
        >
          {{ day }}
        </div>
      </div>
      <!-- <button 
        class="px-2 py-1 border border-gray-300 rounded hover:bg-gray-200 focus:outline-none" 
        @click="scrollRight"
      >
        ▶
      </button> -->
    </div>

    <!-- Timeline Body -->
    <div class="relative h-[1240px] overflow-hidden">
      <!-- Vertical Lines -->
      <div class="absolute inset-0 grid grid-cols-[repeat(auto-fit,minmax(20px,1fr))] h-full">
        <div 
          v-for="day in days" 
          :key="'line-' + day" 
          class="border-l border-gray-300"
        ></div>
      </div>

      <!-- Task Bars -->
      <div
        v-for="(task, index) in tasks"
        :key="task.task_id"
        class="absolute flex items-center h-8 text-sm font-semibold rounded-lg shadow cursor-pointer bg-[#D3ECD0] transform transition-transform duration-200 hover:scale-105"
        :style="getTaskBarStyle(task, index)"
      >
        <div class="flex items-center gap-[1px] pl-4">
          <div class="h-[13px] w-[1px] bg-gray-400"></div>
          <div class="h-[13px] w-[1px] bg-gray-400"></div>
        </div>

        <div class="flex-1 px-4 text-gray-800 h-full flex items-center justify-between">
          {{ task.title }}
        </div>

        <div class="flex items-center gap-[1px] pr-2">
          <div class="h-[13px] w-[1px] bg-gray-400"></div>
          <div class="h-[13px] w-[1px] bg-gray-400"></div>
        </div>
      </div>


    </div>
  </div>

  </div>

  <div v-else class="mt-4">
    <div class="flex justify-center items-center h-full bg-primaryBg px-8 py-2">
      <div class="text-gray-500">No tasks found</div>
    </div>
  </div>

</template>




<script>
import apiClient from "@/axios";

export default {
  name: "GoalTimeline",
  props: {
    projectId: {
      type: Number,
      required: false, // It can either come from the route or be passed as a prop
    },
  },
  data() {
    return {
      project: null, // Stores the project data
      tasks: [], // Tasks fetched from the database
      days: [], // Days in the current month
      currentMonth: new Date().getMonth() + 1, // Current month (1-based index)
      currentYear: new Date().getFullYear(), // Current year
      isLoading: false,
    };
  },
  methods: {
    async fetchProject() {
      this.isLoading = true;
      try {
        const projectId = this.projectId || this.$route.params.projectId; // Get project ID dynamically
        const response = await apiClient.get(`/web/projects/${projectId}`);
        this.project = response.data.data;
        console.log("Project fetched:", this.project);
        this.fetchTasks(projectId);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.$router.push({ name: "NotFound" }); // Redirect to Not Found if project does not exist
        } else {
          console.error("Error fetching project:", error);
        }
      } finally {
        this.isLoading = false;
      }
    },
    async fetchTasks(projectId) {
      this.isLoading = true;
      try {
        const response = await apiClient.get(`/web/projects/${projectId}/tasks`);
        this.tasks = response.data.data;
        console.log("Tasks fetched:", this.tasks);
        this.generateDaysForMonth();
        this.mapTaskDatesToDays();
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
      finally {
        this.isLoading = false;
      }
    },
    generateDaysForMonth() {
      const daysInMonth = new Date(this.currentYear, this.currentMonth, 0).getDate(); // Get days in the current month
      this.days = Array.from({ length: daysInMonth }, (_, i) => i + 1); // Generate days [1, 2, ..., daysInMonth]
    },
    mapTaskDatesToDays() {
      this.isLoading = true;
      this.tasks = this.tasks.map((task) => {
        const startDate = task.start_date ? new Date(task.start_date) : null;
        const dueDate = task.due_date ? new Date(task.due_date) : null;

        return {
          ...task,
          startDay: startDate ? startDate.getDate() : 1, // Default to day 1 if no start_date
          endDay: dueDate ? dueDate.getDate() : this.days.length, // Default to last day if no due_date
        };
      });
      console.log("Mapped tasks:", this.tasks);
      this.isLoading = false;
    },
    getTaskBarStyle(task, index) {
      const dayWidth = 100 / this.days.length; // Percentage width for each day
      const startIndex = task.startDay - 1; // Convert day to 0-based index
      const endIndex = task.endDay - 1; // Convert day to 0-based index

      return {
        left: `${startIndex * dayWidth}%`,
        width: `${(endIndex - startIndex + 1) * dayWidth}%`,
        top: `${index * 40}px`, // Space tasks vertically
      };
    },
    scrollLeft() {
    },
    scrollRight() {
    },
  },
  created() {
    this.fetchProject();
  },
};
</script>



<style scoped>

</style>
